import styled from 'styled-components';

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.brand.primary};

  svg {
    fill: ${({ theme }) => theme.colors.brand.primary};
    margin-right: 10px;
  }
`;
